
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {NgxChartsModule} from '@swimlane/ngx-charts';
import { CommonModule } from '@angular/common';
import {RouterOutlet, RouterModule, Routes } from '@angular/router';
import { PersistenceModule } from 'angular-persistence';
import { AppComponent } from './app.component';
import { EqualValidator } from './equal-validator.directive';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardContentComponent } from './dashboard/dashboard-content.component';
import { ReportComponent } from './transaction/report.component';
import { AccountComponent } from './account/account.component';
import { ProfileComponent } from './account/profile.component';
import { ChangeComponent } from './account/change.component';
import { UserComponent } from './user/user.component';
import { WalletComponent } from './wallet/wallet.component';
import { LookupComponent } from './payment/lookup.component';
import { PaymentComponent } from './payment/payment.component';
import { ReconComponent } from './recon/recon.component';
import { BillerComponent } from './biller/biller.component';
import { MapBillerComponent } from './account/mapbiller.component';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import { HttpModule }    from '@angular/http';
import { loginService }   from '../services/login.service';
import { accountService }   from '../services/account.service';
import { paymentService }   from '../services/payment.service';
import { walletService }   from '../services/wallet.service';
import { billerService }   from '../services/biller.service';
import { SharedService }   from '../services/sharedservices.service';
import { AuthGuard } from './guard/guard';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { userService } from 'services/user.service';
import {DataTableModule} from "angular2-datatable";
import { MyDatePickerModule } from 'mydatepicker';

import { IdleTimeoutService } from '../services/idle-timeout.service';

import { CookieService } from 'ngx-cookie-service';

const appRoutes: Routes = [
  {path: '', redirectTo: 'mca', pathMatch: 'full' },
  {path: 'login', component: LoginComponent },

  {path: 'mca', component: DashboardComponent,
    children:[
      {path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {path: 'dashboard', component: DashboardContentComponent , canActivate: [AuthGuard]},
      {path: 'report', component: ReportComponent , canActivate: [AuthGuard]},
      {path: 'account', component: AccountComponent , canActivate: [AuthGuard] },
      {path: 'profile', component: ProfileComponent , canActivate: [AuthGuard] },
      {path: 'change', component: ChangeComponent , canActivate: [AuthGuard] },
      {path: 'user', component: UserComponent , canActivate: [AuthGuard] },
      {path: 'lookup', component: LookupComponent , canActivate: [AuthGuard] },
      {path: 'payment', component: PaymentComponent , canActivate: [AuthGuard] },
      {path: 'wallet', component: WalletComponent , canActivate: [AuthGuard] },
      {path: 'recon', component: ReconComponent , canActivate: [AuthGuard] },
      {path: 'biller', component: BillerComponent , canActivate: [AuthGuard] }         ,
      {path: 'mapbiller', component: MapBillerComponent , canActivate: [AuthGuard] }
    ]
  }

];

/*export function loadConfig(config: ConfigService) {
  return () => config.load();
}*/

@NgModule({
  declarations: [
    AppComponent, LoginComponent, DashboardComponent, DashboardContentComponent, ReportComponent,AccountComponent, UserComponent, ProfileComponent, EqualValidator,ChangeComponent, LookupComponent, PaymentComponent, WalletComponent, ReconComponent, BillerComponent, MapBillerComponent
  ],
  imports: [
    DataTableModule, ChartsModule,PersistenceModule,BrowserModule,BrowserAnimationsModule,FormsModule,ReactiveFormsModule,HttpModule,  RouterModule.forRoot(appRoutes), NgxChartsModule, MyDatePickerModule
  ],
  providers: [/*ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfig,
      deps: [ConfigService],
      multi: true
    },*/AuthGuard,CookieService,IdleTimeoutService,loginService, accountService,userService, SharedService, paymentService, walletService, billerService],
  bootstrap: [AppComponent]
})
export class AppModule {
  //DataTableModule
  //ChartModule
  //,AlertModule.forRoot()
 }



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/app.module.ts